import axios from "axios";
import { tokenManager } from "../utils/tokenManager";

const RAG_API_URL =
  window.env.REACT_APP_RAG_API_URL || "http://localhost:8002/api/v1";

const apiInstance = axios.create({
  baseURL: RAG_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

tokenManager.setupInterceptors(apiInstance);

export const cacheApi = {
  getCache: () => {
    return apiInstance.get("/auth/me");
  },

  updatePreferences: (data) => {
    return apiInstance.patch(`/me/preferences/`, data);
  },
};
